(function () {
  function setAnswerHeight(answer, height) {
    answer.style.height = height + 'px';
  }

  function openItem(item, answer) {
    item.setAttribute('open', '');
    item.classList.add('product-faq__item--open');
    setAnswerHeight(answer, 0);

    window.requestAnimationFrame(function () {
      setAnswerHeight(answer, answer.scrollHeight);
    });
  }

  function closeItem(item, answer) {
    setAnswerHeight(answer, answer.scrollHeight);
    item.classList.remove('product-faq__item--open');

    window.requestAnimationFrame(function () {
      setAnswerHeight(answer, 0);
    });
  }

  function initProductFaq(root) {
    var summaries = root.querySelectorAll('[data-product-faq-summary]');

    summaries.forEach(function (summary) {
      var item = summary.closest('[data-product-faq-item]');
      var answer = item && item.querySelector('[data-product-faq-answer]');

      if (!item || !answer || item.dataset.productFaqReady === 'true') {
        return;
      }

      item.dataset.productFaqReady = 'true';

      if (item.hasAttribute('open')) {
        item.classList.add('product-faq__item--open');
        setAnswerHeight(answer, answer.scrollHeight);
      }

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (item.classList.contains('product-faq__item--open')) {
          closeItem(item, answer);
        } else {
          openItem(item, answer);
        }
      });

      answer.addEventListener('transitionend', function (event) {
        if (event.propertyName !== 'height') {
          return;
        }

        if (item.classList.contains('product-faq__item--open')) {
          answer.style.height = 'auto';
        } else {
          item.removeAttribute('open');
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductFaq(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProductFaq(event.target);
  });
})();
